<template>
  <div class="sion-personnel people_tran_all" v-loading.fullscreen.lock="loading">
    <div class="sino-panel">
      <!-- 头部 -->
      <header-bar :rightPart="true" @backTo="backTo">
        <template slot="difinePort">
          <div class="people_top" @click="toCheckedPeople">
            <img src="@/images/people.png" alt />
            <span>选中人员</span>
          </div>
        </template>
      </header-bar>
      <!-- 头部 结束 -->
      <div class="panel-top">
        <el-input placeholder="请输入关键字搜索" @input="search" v-model="seach">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <!-- <div class="search-btn" @click="search">搜索</div> -->
      </div>

      <div class="panel-content">
        <template>
          <div class="panel-scroll">
            <!-- 分会list -->
            <div class="scroll-aside">
              <div
                :class="['aside-item',item.active?'item-active':'']"
                v-for="(item,index) in officeData"
                :key="index"
                @click="selectOffice(index)"
              >
                <span class="management-name">{{item.name}}</span>
                <span>({{item.totalNum}})</span>
              </div>
            </div>
            <!-- 分会list -->
            <!-- 科室list -->
            <div class="scroll-aside" ref="asideSecond" style="background:#FFF">
              <div
                :class="['aside-item',item.active?'item-active':'']"
                v-for="(item,index) in currentDepartmentList"
                :key="index"
                @click="selectDept(index)"
              >
                <span class="management-name">{{item.name}}</span>
                <span>({{item.totalNum}})</span>
              </div>
            </div>
            <!-- 科室list 结束 -->

            <div class="scroll-panel" ref="scrollView">
              <!-- 单选 -->
              <div class="item item-radio" v-if="status==1">
                <cube-radio-group>
                  <cube-radio
                    v-for="(item, index) in staffListData.slice(0,currentData)"
                    :key="index"
                    :option="item"
                    v-model="selected"
                  >
                    <div class="panel-item">
                      <div class="item item-phone">
                        <img v-if="item.photo" :src="item.photo" alt />
                        <img v-else src="@/images/doctor.png" alt srcset />
                      </div>
                      <div class="item item-info">
                        <div @click="getPersonDetail(item)">
                          <div class="info-name">{{item.name}}</div>
                          <div class="info-number">性别:{{item.sex == "2" ? "女" : "男"}}</div>
                        </div>
                        <div class="info-number" @click="callTel(item.phone)">
                          手机号:
                          <span>{{item.phone}}</span>
                        </div>
                      </div>
                    </div>
                  </cube-radio>
                </cube-radio-group>
              </div>

              <!-- 多选 -->
              <div
                v-else
                class="panel-item"
                v-for="item in staffListData.slice(0,currentData)"
                :key="item.id"
              >
                <div class="item item-radio" v-if="refreshBox" @click="peopleSelect(item,item.check)">
                  <cube-checkbox v-model="item.check" :option="option"></cube-checkbox>
                </div>
                <div class="item_people" @click="getPersonDetail(item)">
                  <div class="item_flex">
                    <img v-if="item.photo" :src="item.photo" alt />
                    <img v-else src="@/images/doctor.png" alt srcset />
                    <div class="info-name">{{item.name}}</div>
                  </div>
                  <div class="info-number">性别:{{item.sex == "2" ? "女" : "男"}}</div>
                  <div class="info-number" @click="callTel(item.phone)">
                    手机号:
                    <span>{{item.phone}}</span>
                  </div>
                </div>

                <!-- <div class="item item-phone">
                  <img v-if="item.photo" :src="item.photo" alt />
                  <img v-else src="@/images/doctor.png" alt srcset />
                </div>
                <div class="item item-info">
                  <div @click="getPersonDetail(item)">
                    <div class="info-name">{{item.name}}</div>
                    <div class="info-number">性别:{{item.sex == "2" ? "女" : "男"}}</div>
                  </div>
                  <div class="info-number" @click="callTel(item.phone)">手机号:<span>{{item.phone}}</span></div>
                </div>-->
              </div>

              <div
                class="load-more mr-bottom"
                v-if="currentData<staffListData.length"
                @click="loadMore"
              >点击加载更多</div>
              <div class="load-more mr-bottom" v-else>没有更多了</div>
            </div>
          </div>
        </template>
      </div>

      <div class="sino-footer" v-if="status==1">
        <div class="footer-box transfer" @click="selectOK">确定</div>
      </div>

      <div class="sino-footer" v-else>
        <div class="footer-box election" @click="checkAll">
          <cube-checkbox v-model="allCheck">全选</cube-checkbox>
        </div>
        <div class="footer-box transfer" @click="transfer">调动</div>
      </div>
    </div>
    <actionSheet
      v-show="actionShow"
      :sheetList="activeData"
      @selectBranch="selectBranch"
      @close="close"
    ></actionSheet>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import actionSheet from "../../components/actionSheet.vue";
import headerBar from "../../components/headerBar";
import {
  officeTreeData,
  getAppStaffListData,
  officeTransfer
} from "@/common/api";
export default {
  data() {
    return {
      allCheck: false,
      seach: "",
      loading: true,
      currentData: 20,
      officeData: [],
      activeData: [],
      staffListData: [],
      currentDepartment: "",
      unionId: JSON.parse(localStorage.getItem("loginInfo")).unionId,
      actionShow: false,
      option: {
        label: ""
      },
      status: "",
      options: {},
      selected: "",
      selectedPerson: "",
      currentDepartmentList: [], //当前选中的分会下的科室
      currentDepartmentList1:[],
      currentUnionIndex: 0, //当前选中的分会索引
      currentDeptIndex: 0, //当前选中的科室索引
      refreshBox:true,
      objInfo:""
    };
  },
  components: {
    actionSheet,
    headerBar
  },
  watch: {
    seach(value) {
      if (!value) {
        this.getAppStaffList(this.currentDepartment);
      }
    }
  },
  created() {
    this.status = this.$route.query.status ? this.$route.query.status : "";
    this.getOfficeTree();
    // this.getAppStaffList();
    window.addEventListener("scroll", this.scrollBottom);
    this.objInfo = JSON.parse(localStorage.getItem("loginInfo"));
  },
  methods: {
    // 跳转至选中的人员列表
    toCheckedPeople() {
      let checkItem = [];
      this.officeData.forEach(item => {
        item.children &&
          item.children.length &&
          item.children.forEach(item2 => {
            if (item2.staffList && item2.staffList.length)
              checkItem.push(...item2.staffList);
          });
      });
      if (checkItem.length <= 0) return toast(this, "请先选择人员", "error");
      sessionStorage.setItem(
        "checkedStaffList",
        JSON.stringify(this.officeData)
      );
      this.$router.push("/personnelManagementChecked");
    },
    // 返回
    backTo() {
      let checkItem = [];
      this.officeData.forEach(item => {
        item.children &&
          item.children.length &&
          item.children.forEach(item2 => {
            if (item2.staffList && item2.staffList.length)
              checkItem.push(...item2.staffList);
          });
      });
      if (checkItem.length > 0) {
        this.dialogFnConfirm("人员还未调动，确认返回吗？");
        return;
      }
      sessionStorage.removeItem("checkedStaffList");
      this.$router.go(-1);
      // sessionStorage.removeItem('checkedStaffList');
    },
    selectOK() {
      this.staffListData.forEach(item => {
        if (item.id == this.selected) {
          this.selectedPerson = item;
          this.$router.push({
            path: "/condoleApply",
            query: {
              person: this.selectedPerson
            }
          });
        }
      });
      if (!this.selected) {
        toast(this, "请选择申请人员");
      }
    },
    getOfficeTree() {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      let data = {
        unionId:
          loginInfo.identity == "4" || loginInfo.identity == "4"
            ? ""
            : this.unionId
      };
      officeTreeData(data).then(res => {
        if (res.code == 200) {
          res.data.forEach((item, index) => {
            if (index == 0) {
              item.active = true;
            } else {
              item.active = false;
            }
            if (loginInfo.identity == 4 || loginInfo.identity == 5) {
              // if (item.level == 2 || item.level == 3) {
              if (item.level == 3) {
                this.activeData.push({
                  content: item.name,
                  id: item.id,
                  parentId: item.parentId,
                  parentName: item.parentName,
                  type: item.type
                });
              }
            } else if (loginInfo.identity == 3 || loginInfo.identity == 2) {
              if (item.level == 3) {
                this.activeData.push({
                  content: item.name,
                  id: item.id,
                  parentId: item.parentId,
                  parentName: item.parentName,
                  type: item.type
                });
              }
            }
          });
          /* 处理成树状数组 */
          // loginInfo.hospitalName||''
          let arr = [];
          var allUnionArr = [];
          res.data &&res.data.length &&res.data.forEach(item => {
            if (item.level == "2") {
              arr.push(item);
              allUnionArr.push(item)
            }
          });
          res.data &&res.data.length &&res.data.forEach(item => {
            item.active = false;
            arr && arr.forEach(item2 => {
              item2.active = false;
              if (item2.id == item.parentId) {
                if (item2.children) {
                  item2.children.push(item);
                } else {
                  item2.children = [item];
                }
              } else {
                // 分会下无科室时
                item.children=[];
              }
            });
            
          });
          setTimeout(()=>{
            res.data &&res.data.length &&res.data.forEach(item => {
              if (item.level == "1"){
                item.name=loginInfo.hospitalName||'';
                 let arr1 = [{
                  allParentId: item.id,
                  id: item.id,
                  level: "2",
                  name: "全部",
                  parentId: item.id,
                  parentName: item.name,
                  totalNum: item.totalNum,
                  type: "2"
                }]
                item.children=arr1;
              } 
              if (item.level == "1") arr.unshift(item);
            });
            arr && arr.forEach(item => {
              if(item.level!=1){
                  item.children&&item.children.unshift({
                    allParentId: item.id,
                    id: item.id,
                    level: "2",
                    name: "全部",
                    parentId: item.id,
                    parentName: item.name,
                    totalNum: item.totalNum,
                    type: "2"
                  })                 
              }
             
            });

            

            let newOfficeData = JSON.parse(
              sessionStorage.getItem("checkedStaffList")
            );
            if (newOfficeData) {
               this.$set(this,"officeData",newOfficeData);
            } else {
              this.officeData = arr;
            }
             this.selectOffice(0);
           

          },100)
          /* 处理成树状数组 */

          
        }
      });
    },
    loadMore() {
      this.allCheck = false;
      this.currentData += 20;
    },
    getAppStaffList(unionId, name,flag) {
      let baseInfo = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : "";
      const params = {
        unionId: unionId ? unionId : this.unionId,
        name: name ? name : "",
        status: "0,2"
      };
      if (
        !unionId &&
        (baseInfo.identity === "4" || baseInfo.identity === "5")
      ) {
        delete params.unionId;
      }
      var list = this.officeData[this.currentUnionIndex] &&
            this.officeData[this.currentUnionIndex].children[
              this.currentDeptIndex
            ];
      if(list.staff&&!unionId){
        // 如果是第二次点击的时候
        this.staffListData = list.staffListAll;
        this.checkLast(list,list.staffListAll);
        this.loading = false;
      } else {
        getAppStaffListData(params).then(res => {
          if (res.code == 200) {
            res.data.list.forEach(item => {
              item.check = false;
              item.value = item.id;
            });

            if (list.staffList && list.staffList.length == res.data.list.length) {
              this.allCheck = true;
            } else {
              this.allCheck = false;
            }

            list.staff=true;
            if(!flag){
              this.staffListData = res.data.list;
              list.staffListAll = res.data.list;
            }
            this.checkLast(list,res.data.list);
          } else {
            toast(this, res.message, "error");
          }

          this.loading = false;
        });
      }
      
    },
    // 获取上次选中的人员并默认选中
    checkLast(list,currentList){
      if (list && list.staffList && list.staffList.length) {
         var staffList = list.staffList;
        currentList.forEach(item => {
          var flag = false;
          for(var a =0;a<staffList.length;a++){
            if(item.id == staffList[a].id){
              flag = true;
              break;
            } 
          }
          item.check = flag;
        });
      }
      this.isCheckedAll();
    },
    isCheckedAll(){
      // 切换时保留--全选状态
      if(!this.staffListData||!this.staffListData.length)return;
      var isAll = true;
      var arr = this.staffListData.slice(0,this.currentData);
      setTimeout(() => {
        for(var a =0;a<arr.length;a++){
          let item = arr[a];
          if(!item.check){  
            isAll = false;
            break;
          }
        }
        this.allCheck = isAll;
      }, 0);

    },
    // 点击分会
    selectOffice(index,flag) {
      if(!flag){
        this.currentUnionIndex = index;
        this.currentData = 20
        this.$refs.asideSecond.scrollTop = 0;
        this.officeData.forEach(item => {
          item.active = false;
        });
        let item = this.officeData[index];
        this.officeData[index].active = true;
        this.currentDepartment = item.id;
        this.currentDepartmentList = item.children;
        this.selectDept(0);
      } else {
        let item = this.officeData[index];
        this.currentDepartmentList1 = item.children;
        this.selectDept(0,flag);
      }
     
    },
    // 点击科室
    selectDept(index,flag) {
      if(!flag){
        this.currentDeptIndex = index;
        this.currentData = 20;
        this.$refs.scrollView.scrollTop = 0;
        this.currentDepartmentList.forEach(item => {
          item.active = false;
        });
        let item = this.currentDepartmentList[index];
        item.active = true;
        this.getAppStaffList(item.id, this.seach);
        this.currentDepartment = item.id;
      } else {
        let item = this.currentDepartmentList1[index];
        this.getAppStaffList(item.id, this.seach,flag);
      }
    },
    //点击人员
    peopleSelect(staff, check) {

      // 点击全部下的人员时，具体科室的当前人员也选中
      let _index1 = this.officeData.findIndex((item)=>{return staff.unionId==item.id});
      let _index2 = this.officeData[_index1].children.findIndex((item)=>{return staff.deptId==item.id});
      _index1=_index1<0?0:_index1;
      _index2=_index2<0?0:_index2;
    
      this.pushStaff(staff,check,_index1,_index2)
      this.pushStaff(staff,check,_index1,0)
      if(_index1!=0&&_index2!=0)this.pushStaff(staff,check,0,0)

      this.selectOffice(_index1,true);
      this.selectDept(_index2,true);
    },
    //
    pushStaff(staff,check,index1,index2){
      let list = this.officeData[index1].children[index2];
      if (list && list.staffList && list.staffList.length) {
        if (check) {
          // 取消
          list.staffList.forEach((item, index) => {
            if (item.id == staff.id) list.staffList.splice(index, 1);
          });
        } else {
          // 选中
          let staffList = this.officeData[0].children[0].staffList;
          if((staffList&&staffList.length+1)>=100){
            this.refreshBox=false;
            this.$nextTick(()=>{
              this.refreshBox=true;
            })
            return toast(this,'一次最多调动选择100人',"error");
          }
          
          let arr = [...list.staffList,staff];
          arr = this.unique1(arr);
          list.staffList=arr;
        }
      } else {
        list.staffList = [staff];
      }
    },
    // 全选
    checkAll() {
      let staffListData = this.staffListData&&this.staffListData.length&&this.staffListData.slice(0,this.currentData);

      let staffList = this.officeData[0].children[0].staffList;
      let length = 0;
      if (!this.allCheck) length = staffListData.length;
      if((staffList&&staffList.length+length)>=100){
        var that = this;
        setTimeout(()=>{
          that.allCheck = false;
        },0)
        return toast(this,'一次最多调动选择100人',"error");
      }

      staffListData.forEach(item => {
        item.check = !this.allCheck;
      });
      let list = this.officeData[this.currentUnionIndex].children[
        this.currentDeptIndex
      ];
      if (!this.allCheck) {
        // 全选
        list.staffList = JSON.parse(JSON.stringify(staffListData));
        staffListData.forEach(item=>{
          this.peopleSelect(item,false)
        })
      } else {
        // 取消全选
        staffListData.forEach(staff=>{
          let _index1 = this.officeData.findIndex((item)=>{return staff.unionId==item.id});
          let _index2 = this.officeData[_index1].children.findIndex((item)=>{return staff.deptId==item.id});
          _index1=_index1<0?0:_index1;
          _index2=_index2<0?0:_index2;
          this.cleanAllPeople(_index1,_index2);
          this.cleanAllPeople(_index1,0);
          if((_index1!=0&&_index2!=0)||staff.deptId=="")this.cleanAllPeople(0,0)
        })
        
      }
    },
    cleanAllPeople(_index1,_index2){
      let list = this.officeData[_index1].children[_index2];
      list.staffList = [];
    },
    unique1(arr){
      var result = [];
      var obj = {};
      for(var i =0; i<arr.length; i++){
        if(!obj[arr[i].id]){
            result.push(arr[i]);
            obj[arr[i].id] = true;
        }
      }
      return result;
    },
    selectBranch(data) {
      let checkItem = [];
      this.staffListData.forEach(item => {
        if (item.check) {
          checkItem.push(item);
        }
      });
      this.$createDialog({
        title: "提示",
        type: "confirm",
        icon: "cubeic-alert",
        content: `是否将所选人员调入${data.content}?`,
        onConfirm: () => {
          this.getOfficeTransfer(data, checkItem);
          this.actionShow = false;
          document.getElementsByTagName("body")[0].setAttribute("style", "");
          sessionStorage.removeItem("checkedStaffList");
        }
      }).show();
    },
    close() {
      this.actionShow = false;
      document.getElementsByTagName("body")[0].setAttribute("style", "");
    },
    transfer() {
      var self = this;
      let checkItem = [];
      // this.officeData.filter(item => item.level!= '2');
      // this.officeData = this.officeData.filter(item => item.level== '2')
      // console.log(this.officeData.filter(item => item.level!= '2'));
      this.officeData.forEach(item => {
        item.children &&
          item.children.length &&
          item.children.forEach(item2 => {
            if (item2.staffList && item2.staffList.length)
              checkItem.push(...item2.staffList);
          });
      });
      if (checkItem.length <= 0) {
        toast(this, "请选择需要调度的人员", "error");
        return;
      }
      this.actionShow = true;
      document
        .getElementsByTagName("body")[0]
        .setAttribute("style", "position:fixed");
      // this.$createActionSheet({
      //   title: "选择调入分会",
      //   data: self.activeData,
      //   onSelect: (item, index) => {
      //     self
      //       .$createDialog({
      //         title: "提示",
      //         type: "confirm",
      //         icon: "cubeic-alert",
      //         content: `是否将所选人员调入${item.content}?`,
      //         onConfirm: () => {
      //           self.getOfficeTransfer(item, checkItem);
      //         }
      //       })
      //       .show();
      //   }
      // }).show();
    },

    // 拼接
    concatStr(arr) {
      let str = "";
      arr.forEach((item, index) => {
        if (index == arr.length - 1) {
          str += item.name;
        } else {
          str += item.name + "、";
        }
      });
      return str;
    },

    getOfficeTransfer(obj, person) {
      this.loading = true;
      let params = {};
      let personArr = [];
      person.forEach(item => {
        personArr.push(item.id);
      });
      params.staffIds = personArr.join(",");
      
 
      params.userName = this.objInfo.name
      //选择科室
      if (obj.type == 3) {
        params.importDeptId = obj.id; //科室ID
        params.importDeptName = obj.content; //科室Name
        params.importUnionId = obj.parentId; //调入工会id
        params.importUnionName = obj.parentName; //调入工会名称
      } else {
        //选择分会
        params.importUnionId = obj.id; //调入工会id
        params.importUnionName = obj.content; //调入工会名称
      }
      officeTransfer(params).then(res => {
        if (res.code == 200) {
          let duration = 0;
          let successList = res.data.list;
          let failList = res.data.errList;
          if (
            successList.length == 1 &&
            successList.length + failList.length == 1
          ) {
            duration = 3000;
          }

          let str = `<p class='title msg'>${res.message}</p>`;
          if (successList.length != 0) {
            let successPerson = this.concatStr(successList);
            str += `<div class="person-block"><i class='el-icon-success'></i><p class='msg success'>调动成功的人:<span>${successPerson}</span></p></div>`;
          }
          if (failList != 0) {
            let failPerson = this.concatStr(failList);
            str += `<div class="person-block"><i class='el-icon-error'></i><p class='fail'>调动失败的人:${failPerson}</p></div>`;
          }
          this.$message({
            type: "success",
            dangerouslyUseHTMLString: true,
            message: str,
            duration: duration,
            showClose: true,
            customClass: "person"
          });
          this.getAppStaffList(this.currentDepartment);
          this.getOfficeTree();
          this.loading = false;
        } else {
          toast(this, res.message, "error");
          this.loading = false;
        }
      });
    },
    //模糊搜索
    search() {
      if (this.seach) this.getAppStaffList(this.currentDepartment, this.seach);
    },
    callTel(tel) {
      if (!tel) return;
      let telNode = document.createElement("a");
      telNode.style.display = "none";
      telNode.href = "tel:" + tel;
      telNode.click();
    },
    getPersonDetail(option) {
      this.$router.push({
        path: "/persinnelDetail",
        query: {
          id: option.id
        }
      });
    },
    dialogFnConfirm(tip) {
      this.$createDialog({
        type: "confirm",
        title: "提示",
        content: tip,
        confirmBtn: {
          text: "确定",
          active: true,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "取消",
          active: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          sessionStorage.removeItem("checkedStaffList");
          this.$router.go(-1);
        }
      }).show();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/common.styl';

.people_tran_all {
  .action-sheet {
    z-index: 150 !important;
  }

  .item_people {
    border-bottom: 1px solid #E5E5E5;
    width: 72%;

    .item_flex {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
    }

    img {
      width: 23px;
      height: 23px;
      margin-right: 10px;
    }

    .info-number {
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }

    .info-name {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
      line-height: 20px;
      width: 60px;
      ellipsis();
    }
  }

  .cube-checkbox-ui {
    margin-top: 20px;
  }

  .top-box {
    justify-content: space-between;
  }

  .people_top {
    display: flex;
    align-items: center;
    margin-right: 16px;

    img {
      width: 18px;
      margin-right: 4px;
    }

    span {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(41, 189, 187, 1);
    }
  }

  .el-message--success {
    background-color: #fff !important;
    border-color: #e2e2e2 !important;
  }

  .el-message {
    min-width: 100px !important;
    max-width: 80%;
  }

  .person {
    width: 80% !important;

    .person-block {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;
    }

    > i.el-message, > i.el-icon-success {
      display: none;
    }

    p.title, p.success {
      color: #000 !important;
    }

    p.fail {
      color: red !important;
    }

    i {
      display: inline-block;
      margin-right: 5px;
    }

    .msg {
      margin-bottom: 10px;
    }
  }

  .mr-bottom {
    text-align: center;
    font-size: 14px;
    color: #38c7c4;
    padding: 10px 0;
  }

  .sino-footer {
    border-top: 1px solid #E5E5E5;

    .election {
      flex: 5;

      .cube-checkbox-wrap {
        width: 40%;
      }
    }

    .transfer {
      flex: 2;
      background: rgba(56, 199, 196, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);

      &:active {
        background: rgba(56, 199, 196, 0.5);
      }
    }

    .footer-box {
      height: 100%;
    }
  }

  .panel-top {
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 0.6rem;
    padding-top: 40px;

    .search-btn {
      width: 40px;
      margin-left: 0.5rem;
      color: #999;
      white-space: nowrap;
    }

    .el-input__inner {
      background: #EFEFF4;
      border: none;
      height: 32px;
      border-radius: 16px;
      background: rgba(239, 239, 244, 1);
    }

    .el-input__icon {
      line-height: 32px;
    }

    // input::-webkit-input-placeholder{
    // line-height: 32px !important;
    // }
    input {
      padding: 8px 0.8rem !important;
      height: 34px !important;
      font-size: 14px !important;
      line-height: 14px !important;
    }
  }

  .panel-content {
    height: calc(100vh - 100px - 59px);
    overflow-y: scroll;

    .panel-scroll {
      height: 100%;
      display: flex;

      .scroll-aside {
        height: 100%;
        overflow: auto;
        flex: 2.3;

        .aside-item {
          text-align: center;
          // height: 90px;
          padding: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .item-active {
          background: #ffffff !important;
          color: #29BDBB;
        }
      }

      .scroll-aside:nth-child(2) {
        border-right: 1px solid #E5E5E5;
      }

      .scroll-panel {
        flex: 5;
        height: 100%;
        overflow: auto;
        background: #fff;

        .panel-item {
          display: flex;
          height: 71px;
          padding: 0.15rem 0;
          background: #ffffff;
          justify-content: flex-start;
          align-items: center;
          margin-left: 10px;

          .item-radio {
            display: flex;
            align-items: center;
            width: 46px;

            .cube-checkbox {
              padding: 0 0 0 0.16rem;
            }
          }

          .item-phone {
            display: flex;
            align-items: center;
            width: 60px;
            height: 60px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .item-info {
            flex: 1;
            margin-left: 0.3rem;

            .info-name {
              height: 30px;
              line-height: 30px;
              font-size: 16px;
              font-weight: 400;
              color: rgba(53, 53, 53, 1);
            }

            .info-number {
              height: 20px;
              line-height: 20px;
              color: rgba(153, 153, 153, 1);
              font-size: 14px;
            }
          }
        }
      }
    }
  }

  .cube-radio-wrap {
    .cube-radio-ui {
      font-size: 22px;
    }
  }

  .cube-action-sheet-list {
    height: 151px;
    overflow: auto;
    touch-action: auto;
  }

  .cube-action-sheet-space {
    height: 0.03rem;
  }

  .cube-action-sheet-title {
    background: rgba(232, 232, 241, 1);
    color: rgba(136, 136, 136, 1);
    height: 0.2rem;
    line-height: 0.2rem;
    font-size: 15px;
  }

  .management-name {
    display: inline-block;
    line-height: 18px;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // overflow: hidden;
    font-size: 14px;
  }
}
</style>